<div class="page-layout blank p-24" fusePerfectScrollbar>
    <div class="card table-container">
        <p-table #dt [value]="leaveApplications" [scrollable]="true" scrollHeight="calc(100vh - 270px)" [rows]="25"
            [(first)]="first" [rowsPerPageOptions]="[10,25,50,100]" [paginator]="true"
            styleClass="p-datatable-gridlines"
            [globalFilterFields]="['employee.displayName','approver.displayName','leaveRequestDate','leaveType.leaveName','fromDateTime','toDateTime','leaveReason','requestDays','leaveStatus']"
            (onPage)="call()" [rowHover]="true" (onFilter)="onFilter($event)">
            <ng-template pTemplate="caption">
                <div class="p-d-flex p-ai-center p-jc-between">
                    <div style="display: flex;">
                        <button pButton pRipple icon="pi pi-thumbs-up"
                            class="p-button-rounded p-button-success  pull-right p-mr-2" pTooltip="Approve"
                            tooltipPosition="top" (click)="approveStatus()" *ngIf="showButton"></button>
                        <button pButton pRipple icon="pi pi-thumbs-down"
                            class="p-button-rounded p-button-warning  pull-right p-mr-2" pTooltip="Reject"
                            tooltipPosition="top" (click)="rejectStatus()" *ngIf="showButton"></button>
                        <h5 class="p-m-0">Total {{leaveApplications ? leaveApplications.length : '' }} Leave
                            Applications<span *ngIf="total && total != leaveApplications?.length"> (Showing {{total}}
                                Records)</span></h5>
                    </div>

                    <div>
                        <button pButton pRipple icon="pi pi-plus" *ngIf="menuAccess.canAdd"
                            class="p-button-rounded p-button-info p-mr-2 pull-right" pTooltip="Add"
                            tooltipPosition="top" (click)="openNew()"></button>
                        <button pButton pRipple icon="pi pi-file-excel" pTooltip="Export to excel" tooltipPosition="top"
                            (click)="ExportExcel()" class="p-button-rounded p-button-success p-mr-2"></button>
                        <button pButton pRipple icon="pi pi-filter"
                            class="p-button-rounded p-button-secondary p-mr-2 pull-right" pTooltip="Advance Filter"
                            tooltipPosition="top" (click)="openFilter()"></button>
                        <span class="p-input-icon-left pull-right p-mr-2">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                                placeholder="Search..." />
                        </span>

                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th style="max-width: 40px"
                        *ngIf="((menuAccess.canDelete || menuAccess.canEdit) && isAdmin) || isUser">
                        <p-checkbox name="thumbId" [(checked)]="checked" [value]="dt.rows"
                            (click)="totalRecord(dt.rows)" [binary]="true" [(ngModel)]="allOverTimeStatus"></p-checkbox>
                    </th>
                    
                    <th pSortableColumn="employee.displayName" style="max-width: 180px;width: 180px;">Employee
                        <p-sortIcon field="employee.displayName"></p-sortIcon>
                    </th>
                    <th pSortableColumn="leaveRequestDate" style="max-width: 130px;width: 130px;">Request Date
                        <p-sortIcon field="leaveRequestDate">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="leaveType.leaveName" style="max-width: 120px;width: 120px;">Leave Type
                        <p-sortIcon field="leaveType.leaveName"></p-sortIcon>
                    </th>
                    <th pSortableColumn="fromDateTime" style="max-width: 175px;width: 175px;">From Date
                        <p-sortIcon field="fromDateTime">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="toDateTime" style="max-width: 175px;width: 175px;">To Date
                        <p-sortIcon field="toDateTime">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="leaveReason" style="min-width: 300px;width: 300px;">Reason
                        <p-sortIcon field="leaveReason">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="approver.displayName" style="max-width: 180px;width: 180px;">Approver
                        <p-sortIcon field="approver.displayName"></p-sortIcon>
                    </th>

                    <th pSortableColumn="leaveStatus" style="max-width: 87px;width: 87px;">Status
                        <p-sortIcon field="leaveStatus">
                        </p-sortIcon>
                    </th>
                    <th alignFrozen="right" pFrozenColumn class="p-jc-center p-justify-center" *ngIf="menuAccess.canDelete || menuAccess.canEdit" style="max-width: 90px;width: 90px;">Action
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-leaveApplication>
                <tr>
                    <td style="max-width: 40px"
                        *ngIf="((menuAccess.canDelete || menuAccess.canEdit) && isAdmin) || isUser">
                        <p-checkbox name="overTimeID" [value]="leaveApplication.id" (onChange)="hideButtons()"
                            *ngIf="isAdmin || (!isAdmin && isUser && currentUser.employeeId != leaveApplication.employee.id && leaveApplication.leaveStatus == 0 && currentUser.isApprover)" [(ngModel)]="selectedValue"></p-checkbox>
                    </td>
                    
                    <td style="max-width: 180px;width: 180px;">{{leaveApplication.employee.displayName}}</td>
                    <td style="max-width: 130px;width: 130px;">{{leaveApplication.leaveRequestDate |date : dateFormat}}
                    </td>
                    <td style="max-width: 120px;width: 120px;">{{leaveApplication.leaveType.leaveName}}</td>
                    <td style="max-width: 175px;width: 175px;">{{leaveApplication.fromDateTime | date:dateTimeformat}}
                    </td>
                    <td style="max-width: 175px;width: 175px;">{{leaveApplication.toDateTime | date:dateTimeformat}}
                    </td>
                    <td style="min-width: 300px;width: 300px; word-break: normal; overflow-wrap: anywhere;"
                        [pTooltip]="leaveApplication.leaveReason" tooltipPosition="top">{{leaveApplication.leaveReason}}
                    </td>
                    <td style="max-width: 180px;width: 180px;">{{leaveApplication.approver.displayName}}</td>
                    <td style="max-width: 87px;width: 87px;" class="p-jc-center icon-button">
                        <div class="p-grid p-d-flex p-ai-center">
                            <div class="p-col-5">
                                <i class="pi p-button-text " pButton style="padding: 0%;"
                                    [ngClass]="{'pi-thumbs-up p-button-success':leaveApplication.leaveStatus == 1 , 'pi-clock  p-button-danger': leaveApplication.leaveStatus == 0,'pi-thumbs-down p-button-warning': leaveApplication.leaveStatus == 2}"
                                    [pTooltip]="leaveApplication.leaveStatus == 0 ? 'Pending' : leaveApplication.leaveStatus == 1 ? 'Approved' : 'Rejected'"
                                    tooltipPosition="top"></i>
                            </div>
                        </div>
                    </td>
                    <td alignFrozen="right" pFrozenColumn *ngIf="menuAccess.canDelete || menuAccess.canEdit" style="max-width: 90px;width: 90px;">
                        <button pButton pRipple icon="pi pi-pencil" pTooltip="Edit" tooltipPosition="top"
                            class="p-button-rounded p-button-success p-mr-2" *ngIf="menuAccess.canEdit"
                            (click)="editLeaveApplication(leaveApplication)"></button>
                        <button pButton pRipple icon="pi pi-trash" pTooltip="Delete" tooltipPosition="top"
                            class="p-button-rounded p-button-warning" *ngIf="menuAccess.canDelete"
                            (click)="deleteLeaveApplication(leaveApplication)"></button>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="7">
                        <div class="notFound">
                            Leave Data Not found.
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>

<p-dialog [(visible)]="leaveApplicationDialog" [style]="{width: '450px'}" header="Leave Application Details"
    [modal]="true" styleClass="p-fluid" [baseZIndex]="10" (onHide)="onHide()">
    <ng-template pTemplate="content">
        <form #leaveApplicationForm="ngForm" (ngSubmit)="leaveApplicationForm.form.valid && saveLeaveApplication()">
            <div class="p-field">
                <label for="employee">Employee Name<span class="p-pl-1 p-error">*</span></label>
                <p-dropdown [options]="employees" name="employees" autoWidth="false" [style]="{'width':'100%'}"
                    [filter]="true" filterBy="employeeName" [(ngModel)]="selectedEmployee" required
                    optionLabel="employeeName" optionValue="id" (onChange)="isSelectedEmployee()"
                    placeholder="Select Employee Name" appendTo="body" [disabled]="editDisable">
                </p-dropdown>
                <small class="p-error" *ngIf="!selectedEmployee && leaveApplicationForm.submitted">Please Select
                    Employee Name</small>
            </div>
            <div class="p-field">
                <div class="p-d-flex p-jc-between">
                    <label for="leaveType">Leave Type <span class="p-pl-1 p-error">*</span></label>
                    <div *ngIf="isShowBalance"><label [ngClass]="(balance >= 0) ? 'label-green' : 'label-red'"
                            style="font-weight: bold;">Balance: <span style="font-size: 15px">{{balance}} <span *ngIf="leavetypename == 'Short Leave'"> Minutes</span></span></label>
                    </div>
                </div>
                <p-dropdown [options]="leaveTypes" name="leaveType" [(ngModel)]="selectedLeaveType" required
                    optionLabel="leaveName" (onChange)="selectedTimes()" optionValue="id"
                    placeholder="Select Leave Type">
                </p-dropdown>
                <small class="p-error" *ngIf="!selectedLeaveType && leaveApplicationForm.submitted">Please Select Leave
                    Type</small>
                <small class="p-error" *ngIf="isBalanceExists">You Don't Have Sufficient Balance. You Entered
                    {{dayDiff}} Days Leave And You Have {{balance}} Balance Leave.
                </small>
            </div>
            <div class="p-field" *ngIf="isLeaveDisabled">
                <label for="fromDateTime">From Date <span class="p-pl-1 p-error">*</span></label>
                <p-calendar inputId="fromDateTime" [(ngModel)]="leaveApplication.fromDateTime"
                    [dateFormat]="calendarDateFormat" required appendTo="body" #fromDateTime="ngModel"
                    name="fromDateTime" dataType="date" (onSelect)="setDateValue()"></p-calendar>
                <small class="p-error"
                    *ngIf="fromDateTime.errors?.required &&(fromDateTime.touched || fromDateTime.dirty || leaveApplicationForm.submitted )">Please
                    Select From Date
                </small>
            </div>
            <div class="p-field p-grid" *ngIf="!isLeaveDisabled">
                <div class="p-col-6">
                    <label for="fromDateTime">From Date <span class="p-pl-1 p-error">*</span></label>
                    <p-calendar inputId="fromDateTime" [(ngModel)]="leaveApplication.fromDateTime"
                        [dateFormat]="calendarDateFormat" required appendTo="body" #fromDateTime="ngModel"
                        (onSelect)="dayCalculation()" name="fromDateTime" dataType="date"
                        [maxDate]="leaveApplication.toDateTime"></p-calendar>
                    <small class="p-error"
                        *ngIf="fromDateTime.errors?.required &&(fromDateTime.touched || fromDateTime.dirty || leaveApplicationForm.submitted )">Please
                        Select From Date
                    </small>
                </div>
                <div class="p-col-6">
                    <label for="toDateTime">To Date <span class="p-pl-1 p-error">*</span></label>
                    <p-calendar inputId="toDateTime" appendTo="body" [(ngModel)]="leaveApplication.toDateTime" required
                        [minDate]="leaveApplication.fromDateTime" #toDateTime="ngModel" name="toDateTime"
                        (onSelect)="dayCalculation()" dataType="date" [dateFormat]="calendarDateFormat"></p-calendar>
                    <small class="p-error" *ngIf="toDateTime.errors?.required && leaveApplicationForm.submitted">Please
                        Select To Date
                    </small>
                </div>
            </div>
            <div class="p-field p-grid" *ngIf="isShortorHalfLeave">
                <div class="p-col-6">
                    <label for="fromTime">From Time <span class="p-pl-1 p-error">*</span></label>
                    <input class="p-inputtext p-component" name="txtfromtime" [(ngModel)]="fromTime"
                        aria-label="default time" [ngxTimepicker]="default" [value]="fromTime" readonly>
                    <ngx-material-timepicker #default (timeSet)="setFromTimeFromTimePicker($event)">
                    </ngx-material-timepicker>

                </div>
                <div class="p-col-6">
                    <label for="toTime">To Time <span class="p-pl-1 p-error">*</span></label>
                    <input class="p-inputtext p-component" name="txttotime" [(ngModel)]="toTime"
                        aria-label="default time" [ngxTimepicker]="picker" [value]="toTime" readonly>
                    <ngx-material-timepicker #picker (timeSet)="setToTimeFromTimePicker($event)">
                    </ngx-material-timepicker>
                </div>
                <div class="p-col-12">
                    <div class="p-d-flex">
                        <label>{{totalDay}}</label>
                    </div>
                    <small class="p-error"
                        *ngIf="!isValidTime && minimumTime && leaveApplication.toDateTime && leaveApplication.fromDateTime && leaveApplicationForm.submitted">{{leavetype}}
                        should not be greater than {{time}} minute
                    </small>
                    <small class="p-error"
                        *ngIf="!minimumTime && leaveApplication.toDateTime && leaveApplication.fromDateTime && leaveApplicationForm.submitted">Time
                        should be greater than 15 minute
                    </small>
                </div>
            </div>
            <div class="p-field">
                <label for="leaveReason">Reason <span class="p-pl-1 p-error">*</span></label>
                <textarea id="leaveReason" name="leaveReason" #leaveReason="ngModel" pInputTextarea required
                    [minlength]="remarkMaxLength" [(ngModel)]="leaveApplication.leaveReason" required rows="3"
                    cols="100%"></textarea>
                <small class="p-error" *ngIf="leaveReason.errors?.required  && leaveApplicationForm.submitted">Please
                    Give Valid Reason For Leave
                </small>
                <small class="p-error" *ngIf="leaveApplicationForm.submitted && leaveReason.errors?.minlength ">
                    Reason Should Be Minimum {{remarkMaxLength}} Character</small>
            </div>
            <div class="p-field">
                <label for="approver">Approver Name<span class="p-pl-1 p-error">*</span></label>
                <p-dropdown [options]="approvers" name="approver" #approver="ngModel" [(ngModel)]="selectedApprover"
                    autoWidth="false" [style]="{'width':'100%'}" required appendTo="body" [filter]="true"
                    filterBy="employeeName" optionLabel="employeeName" optionValue="id" [disabled]="ApproverDisable"
                    placeholder="Select Approver Name">
                </p-dropdown>
                <small class="p-error" *ngIf="!selectedApprover && leaveApplicationForm.submitted">Please Select
                    Approver Name</small>
            </div>
            <div class="p-field" *ngIf="rolewiseData == 0">
                <label for="Status">Status <span class="p-pl-1 p-error">*</span></label>
                <p-dropdown [options]="status" name="Status" autoWidth="false" [style]="{'width':'100%'}"
                    appendTo="body" [(ngModel)]="selectedstatus" optionLabel="name" optionValue="value"
                    placeholder="Select Status">
                </p-dropdown>
                <small class="p-error"
                    *ngIf="(!selectedstatus && selectedstatus != 0) && leaveApplicationForm.submitted">Please Select
                    Status</small>
            </div>
            <div class="p-field p-grid">
                <div class="p-col-6"></div>
                <div class="p-col-6">
                    <div class="col-md-3">
                        <button pButton pRipple label="Save" icon="pi pi-check"
                            class="p-button-text parent-custom-button " type="submit"></button>
                        <button pButton pRipple label="Cancel" icon="pi pi-times"
                            class="p-button-text parent-custom-button  p-button-danger" type="button"
                            (click)="hideDialogs()"></button>
                    </div>
                </div>
            </div>
        </form>
    </ng-template>
</p-dialog>

<p-confirmDialog [style]="{width: '450px'}" [baseZIndex]="50"></p-confirmDialog>

<app-filter [filterDialog]="filterDialog" [filter]="filter" [accessFilter]="accessFilter"
    (hideDialog)="hideDialog($event)" (resetDialog)="resetDialog($event)" (submitDialogs)="submitDialogs($event)">
</app-filter>